import { Tooltip } from "@mui/material";
import SparklesIcon from "@entrilia/shared/icons/SparklesIcon";

interface Props {
  tooltip: string;
}

const AutoFilledMarker = ({ tooltip }: Props) => (
  <Tooltip arrow title={tooltip}>
    <SparklesIcon color="primary" aria-label={tooltip} />
  </Tooltip>
);

export default AutoFilledMarker;
